import { Component, EventEmitter, Injector, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { GridOptions, RowClickedEvent } from 'ag-grid';
import { DecimalPipe } from '@angular/common';
import {
  IBilling,
  ICharge,
  ICredit,
  IDataEditAging,
  IResponCharges,
  ITripBillingInfo
} from '../../../../../../core/interfaces/billing.interface';
import { T2CardComponent } from '../../../../../../trip2-theme/components/t2-card/t2-card.component';
import { ComunicationEditBilling } from '../../comunication-edit-billing';
import { BillingEditService } from '../../../../../../core/services/billing-edit.service';
import { Subscription } from 'rxjs/Subscription';
import { IResponseSuccess } from '../../../../../../core/interfaces/response.interface';
import { ILocation } from '../../../../../../core/interfaces/location.interface';
import { EnumTypeAlertRider } from '../../../../../rider/services/rider-alert.service';
import { IMyDateModel, IMyOptions } from 'mydatepicker';
import { ParentModule } from '../../../../../A2-utils/ParentClass/parent-module';
import { Observable } from 'rxjs/Observable';
import { messagePermits } from '../../../../../A2-utils/export-functions/functions-services';
import { T2LoadingService } from '../../../../../../trip2-theme/components/t2-loading/t2-loading.service';
import { ReservationService } from 'app/pages/trip-reservations/reservations.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { DataProcessingService } from 'app/pages/data-processing/data-processing.service';
import { Response } from '@angular/http';
import { PayorsService } from 'app/pages/payors/payors.service';
import { IReasonForTransport } from 'app/core/interfaces/reason-transport.interface';
import { TripChargesEnum } from 'app/core/enums/trips-charges.enum';

declare const moment: any;
@Component({
  selector: 'app-add-charges-credits',
  templateUrl: './add-charges-credits.component.html',
  styleUrls: ['./add-charges-credits.component.scss']
})
export class AddChargesCreditsComponent extends ParentModule implements OnInit, OnDestroy, OnChanges {

  public gridCharges: GridOptions;
  public gridCredits: GridOptions;
  public rowDataCharges: ICharge[];
  public rowDataCredits: ICredit[];
  public subscrip: Subscription[] = [];
  public edit: boolean;
  public credit: boolean;
  nonnegotiable: boolean;
  isDuplicate: boolean;
  public reversing = false;
  public chargeSelected: ICharge = {} as ICharge;
  public creditSelected: ICredit = {} as ICredit;
  public summaryByTrip: IBilling = {} as IBilling;
  public aging: string;
  public changeAging: string;
  public tripId: number;
  public billingInfo: ITripBillingInfo;
  public mask_date = [/[0-1]/, /[0-9]/, '/', /[0-3]/, /[0-9]/, '/', /[0-3]/, /[0-9]/, /[0-9]/, /[0-9]/];
  @Input() tripidInput: number;
  @Input() rideridInput: number;
  @Input() brokerId: number;
  @Input() isModifierRequired: boolean;
  @Input() pickup: ILocation;
  @Input() dropoff: ILocation;
  @Input() isEdit: boolean;
  @Input() reasonfortransport: any = [];
  @Output() updateTrip: EventEmitter<number> = new EventEmitter<number>();
  @Output() reloadTripId: EventEmitter<number> = new EventEmitter<number>();
  @ViewChild('modalCreate') modalCreate: T2CardComponent;
  @ViewChild('modalEditAging') modalEditAging: T2CardComponent;
  public typeAlertRider = EnumTypeAlertRider;
  public myDatePicker: IMyOptions = {
    dateFormat: 'mm-dd-yyyy',
    editableDateField: true,
    showSelectorArrow: true,
  };
  private actionsBilling$: Observable<string[]> = this.$actions.asObservable();
  titleCharge: string;
  tripReasonTransportId: number;
  tripReasonTransport: IReasonForTransport;
  cptCodeBase: string;
  cptCodeMile: string;
  constructor(
    public communication: ComunicationEditBilling,
    private service: BillingEditService,
    private decimal: DecimalPipe,
    private _loadingAdd: T2LoadingService,
    protected Inject: Injector,
    private toastrAlertHelper: ToastrAlertHelper,
    private sweetAlertHelper: SweetAlertHelper,
    private dataProcessingService: DataProcessingService,
    private reservationService: ReservationService,
    private payorServices: PayorsService
  ) {
    super('app-add-charges-credits', Inject);
    this.createGrid();
    this._loadingAdd.show();
    this.subscrip.push(this.actionsBilling$.subscribe(
      () => {this._loadingAdd.hiden(); }
    ));
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['tripidInput'] && this.tripidInput) {
      this.tripId = this.tripidInput;
      this.verifyTripDuplicate();
      this.verifyTripNonNegotiable();
    }
  }

  ngOnInit() {
    this.communication.riderid = this.rideridInput;
    this.listenObservables();
    this.getChargesAndCreditsByTrip();
  }

  /**@name listenObservables
   * @description escucha los cambios de los Observables
   */
  listenObservables() {
    this.subscrip.push(this.communication.getOpenCreate.subscribe(
      (open: boolean) => {
        switch (open) {
          case true:
            {this.modalCreate.open();
            }
            break;
          case false:
            {this.modalCreate.close(); }
            break;
        }
      }
    ),
    this.reservationService.tripReasonTransport$.subscribe({
      next: (tripReasonTransport: any) => {
        if (tripReasonTransport) {
          this.tripReasonTransportId = tripReasonTransport;
        }
      },
      error: (err) => {
        this.sweetAlertHelper.captureException(err);
      },
    })
    );
    if (this.tripReasonTransportId) {
      this.subscrip.push(
        this.payorServices.getReasonById(this.tripReasonTransportId).subscribe({
          next: (reasonForTransport: IReasonForTransport) => {
            if (reasonForTransport) {
              this.tripReasonTransport = reasonForTransport;
            }
            if (
              this.tripReasonTransport &&
              this.tripReasonTransport.cptcodebase &&
              this.tripReasonTransport.modifier
            ) {
              this.cptCodeBase =
                this.tripReasonTransport.cptcodebase +
                this.tripReasonTransport.modifier;
            }
            if (
              this.tripReasonTransport &&
              this.tripReasonTransport.cptcodemiles &&
              this.tripReasonTransport.modifier
            ) {
              this.cptCodeMile =
                this.tripReasonTransport.cptcodemiles +
                this.tripReasonTransport.modifier;
            }
          },
          error: (err) => {
            this.sweetAlertHelper.captureException(err);
          },
        })
      );
    }
    this.subscrip.push(this.communication.getUpDate.subscribe(
      (update: boolean) => {
          if (update) {this.getChargesAndCreditsByTrip(); }
      }
      )
    );
  }
  disabledDates(date: Date): IMyOptions {
    return {
      dateFormat: 'mm-dd-yyyy',
      editableDateField: true,
      showSelectorArrow: true,
      disableUntil: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate() - 1
      }
    };
  }
  /**@name createGrid
   * @description crea el la grilla
   */
  createGrid() {
    this.gridCharges = {} as GridOptions;
    this.gridCredits = {} as GridOptions;
    this.settingGrid(this.gridCharges, false);
    this.settingGrid(this.gridCredits, true);
  }

  /**@name settingGrid
   * @description configura las grillas
   * @param grid = la gilla
   * @param isCredit = Si es de credito
   */
  settingGrid(grid: GridOptions, isCredit: boolean) {
    grid.getRowStyle = this.getRowStyle;
    grid.columnDefs = this.defineColumns(isCredit);
    grid.onRowClicked = (event: RowClickedEvent) => {
     this.clearChaegeAndCreditSelected();
     const data = event.data;
     data['sequence'] = event.rowIndex + 1;
     if (this.isEdit) {
       isCredit ? this.creditSelected = data : this.chargeSelected = data;
     }
      this.setRowSelectedGrid(isCredit);
    };
    grid.onRowDoubleClicked = (): void => {
      if (this.isEdit && !isCredit) {
        this.onEditCharge();
      }
    };
  }

  /**@name defineColumns
   * @description define las columnas para las grillas
   * @param credit = is credit
   **/
  defineColumns(credit?: boolean) {
    const elIs = this;
    return [
      /* {
        colId: 'id',
        width: 30,
        checkboxSelection: true,
        headerCheckboxSelection: true,
      }, */
      {
        headerName: 'Seq',
        field: 'sequence',
        colId: 'sequence',
        cellRenderer: (params) => {
          return params.rowIndex + 1;
        },
        width: 50
      },
      {
        headerName: 'CPT/MOD',
        field: 'cptmodifiers',
        colId: 'cptmodifiers',
        width: 60,
        hide: credit,
      },
      {
        headerName: 'Charge Description',
        field: 'charge.description',
        colId: 'charge',
        width: 140,
        hide: credit,
      },
      {
        headerName: 'Payor',
        field: 'payor.description',
        colId: 'payor',
        width: 145,
         hide: !credit,
      },
      {
        headerName: 'Qty',
        field: 'units',
        colId: 'units',
        width: 60,
        hide: credit,
        cellStyle: {textAlign: 'center'},
      },
      {
        headerName: 'Credit',
        field: 'credit.description',
        colId: 'credit',
        width: 118,
        hide: !credit,
      },
      {
        headerName: 'Unit Price',
        field: 'unitamount',
        colId: 'unitamount',
        width: 75,
        hide: credit,
        cellStyle: { textAlign: 'right' },
        cellRenderer: function (params) {
          return elIs.transformCoin(params.data.unitamount);
        }
      },
      {
        headerName: credit ? 'Amount' : 'Price',
        field: 'amount',
        colId: 'amount',
        width: 75,
        cellStyle: { textAlign: 'right' },
        cellRenderer: function (params) {
          return elIs.transformCoin(params.data.amount);
        }
      },
      {
        headerName: 'Chrg',
        field: 'tripcharge.charge.description',
        colId: 'credit',
        width: 100,
        hide: !credit,
        cellRenderer: (params) => {
          if (params && params.data && params.data.tripcharge) {
            return params.data.tripcharge.charge.description;
          }
        }
      },
      {
        headerName: 'Claim Number',
        field: 'claimno',
        colId: 'claimno',
        width: 135,
      },
      {
        headerName: 'Procedure',
        field: 'procd',
        colId: 'procd',
        width: 95,
      },
      {
        headerName: 'Modifier',
        field: 'modifier',
        colId: 'modifier',
        width: 85,
      },
      {
        headerName: 'Denial code',
        field: 'denial.denialcode',
        colId: 'denialcode',
        width: 100,
        hide: !credit,
      },
      {
        headerName: 'Denial Code Description',
        field: 'denial.description',
        colId: 'credit',
        width: 100,
        hide: !credit
      },
      {
        headerName: 'Check #',
        field: 'checknumber',
        colId: 'checknumber',
        width: 100,
        hide: !credit,
      },
      {
        headerName: 'Check Date',
        field: 'checkdateformatted',
        colId: 'checkdateformatted',
        width: 100,
        hide: !credit,
      },
      {
        headerName: 'Deposit Date',
        field: 'depositdateformatted',
        colId: 'depositdateformatted',
        width: 100,
        hide: !credit,
      },
      {
        headerName: 'Post Date and Time',
        field: 'modifiedonformatted',
        colId: 'modifiedonformatted',
        width: 130,
        cellStyle: {textAlign: 'center'},
      },
      {
        headerName: 'Reversing',
        field: 'isactive',
        colId: 'isactive',
        width: 57,
        cellStyle: {textAlign: 'center'},
        cellRenderer: function (params) {
          return params.data.isactive ? 'No' : 'Yes';
        }
      },
      {
        headerName: 'User',
        field: 'userprofile.fullname',
        colId: 'userprofile',
        width: 169,
      },
    ];
  }


  /**@name transformCoin
   * @description Transforma el valor adicionando el sibolo de peso $
   * @param data = datos a modificar
   */
  transformCoin(data) {
    const value = this.decimal.transform(data, '1.2-2');
    return'$' + value;
  }


  /**@name addChargesAndCredits
   * @description abre el form para crear charge o credit segun credit
   * @param credit = is credit
   **/
  addChargesAndCredits(credit: boolean) {
    this.titleCharge = 'Add charge';
    this.clearChaegeAndCreditSelected();
    this.communication.credit = credit;
    this.modalCreate.open();
  }

  onEditCharge() {
    if (this.chargeSelected.sequence) {
      this.titleCharge = 'Edit charge';
      this.communication.credit = false;
      this.modalCreate.open();
    } else {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Select',
        text: 'select a Charge',
        type: 'info',
      });
    }
  }

  recalculateCharges() {
    const trips = [];
    trips.push(this.tripId);
    if (trips.length) {
      this._loading.show();
      this.subscrip.push(
        this.service
          .recalculateCharges(trips)
          .finally(() => {
            this._loading.hiden();
          })
          .subscribe(
            (success) => {
              this.toastrAlertHelper.success(success.message);
              this.getChargesByTrip(this.tripId, this.reversing);
              this.dataProcessingService.getReloadGrid(true);
              this.reservationService.reloadTotalAmountSubject.next(true);
            },
            (error) => {
              this.toastrAlertHelper.error(error.message);
            }
          )
      );
    }
    this.gridCharges.api.deselectAll();
  }

  /**@name clearChaegeAndCreditSelected
   * @description limpia charge o credit seleccionado
   */
  clearChaegeAndCreditSelected() {
    if (this.chargeSelected.chargeid) {this.chargeSelected = {} as ICharge; }
    if (this.creditSelected.creditid) {this.creditSelected = {} as ICredit; }
  }
  /**@name getChargesByTrip
   * @description trae los chages del trip
   * @param tripid
   * @param inactive
   */
  getChargesByTrip(tripid: number, inactive: boolean) {
    this.rowDataCharges = [];
    this.subscrip.push(this.service.getChagesByTrip(tripid, inactive).subscribe(
      (charges: IResponCharges) => {
        this.billingInfo = charges.tripbilling;
        this.billingInfo.tripid = charges.tripbilling.tripid ? charges.tripbilling.tripid : tripid;
        this.rowDataCharges = charges.tripcharge;
        this.communication.chargesByTrip = charges.tripcharge ? charges.tripcharge : [];
        this.summaryByTrip = charges.summary;
        this.aging = charges.tripbilling.aging ? charges.tripbilling.aging : charges.tripbilling.dateofservice;
        this.myDatePicker = this.disabledDates(new Date(charges.tripbilling.dateofservice));
        },
    ));
  }

  /**@name geTCreditsByTrip
   * @description trae los credit del trip
   * @param tripid
   * @param inactive
   */
  geTCreditsByTrip(tripid: number, inactive: boolean) {
    this.subscrip.push(this.service.getCreditsByTrip(tripid, inactive).subscribe(
      (credits) => {
        this.rowDataCredits = credits;
        this.communication.creditsByTrip = credits;
        },
    ));
  }

  /**@name getChargesAndCreditsByTrip
   * @description trae los credits y charges del trip
   */
  getChargesAndCreditsByTrip() {
    this.getChargesByTrip(this.tripId, this.reversing);
    this.geTCreditsByTrip(this.tripId, this.reversing);
  }


  /**@name deleteChargesAndCredits
   * @description elimina un credit o un charge del trip segun credit
   * @param credit
   */
  deleteChargesAndCredits(credit: boolean) {
    if (this.creditSelected.sequence || this.chargeSelected.sequence) {
      const text: string = credit ?
        `Delete Credit: ${this.creditSelected.sequence} - ${this.creditSelected.credit.description}` :
        `Delete Charge: ${this.chargeSelected.sequence} - ${this.chargeSelected.charge.description}`;
      this.sweetAlertHelper.createCustomAlert({
        title: 'Delete',
        text: text,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'No',
        allowOutsideClick: false,
        allowEnterKey: false
      }).then(
        respon => {
          if (respon.value) {
            switch (credit) {
              case true: {this.deleteCredit(); }
                break;
              case false: {this.deleteCharge(); }
                break;
            }
          }else {
            this.creditSelected = {} as ICredit;
            this.chargeSelected = {} as ICharge;
          }
        }
      );
    } else {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Select',
        text: credit ? 'select a Credit' : 'select a Charge',
        type: 'info',
      });
    }
  }

  /**@name deleteCredit
   * @description elimina un credit del trip
   */
  deleteCredit() {
    if (this.creditSelected.creditid) {
      this.service.deleteCredit(this.creditSelected.tripcreditid).subscribe(
        (success: IResponseSuccess) => {
          this.creditSelected = {} as ICredit;
          this.message('success', success.message);
          this.getChargesAndCreditsByTrip();
          },
        error => {this.message('error', error.message); }
        );
    }
  }

  /**@name deleteCharge
   * @description elimina un charge del trip
   */
  deleteCharge() {
    if (this.chargeSelected.chargeid) {
      this.service.deleteCharge(this.chargeSelected.tripchargeid).subscribe(
        (success: IResponseSuccess) => {
          this.chargeSelected = {} as ICharge;
          this.message('success', success.message);
          this.getChargesAndCreditsByTrip();
        },
        error => {this.message('error', error.message); }
      );
    }
  }

  /**@name deleteCharge
   * @description elimina un charge del trip
   */
  message(type: any, message?: string) {
    switch (type) {
      case 'success': {
        this.sweetAlertHelper.createCustomAlert({
          title: 'Successful',
          text: message ? message : 'Successful Action',
          type: type,

        });
      }
        break;
      case 'error': {
        this.sweetAlertHelper.createCustomAlert({
          title: 'Error',
          text: message ? message : 'Error Action',
          type: type,

        });
      }
      break;
      case '':
        break;
    }
  }

  public onChangereversing(): void {
    this.getChargesAndCreditsByTrip();
  }

  onOpenEditAging(): void {
    if (this.isAllowedAction('Edit Aging')) {
      this.modalEditAging.open();
    } else {
      messagePermits('Edit Aging');
    }
  }
  onCloseEditAging(): void {
    this.modalEditAging.close();
  }
  public onEditAging(): void {
    this.sweetAlertHelper.createCustomAlert({
      title: 'Edit Aging',
      text: 'Are you sure you want to edit the aging?',
      type: 'warning',
      showCancelButton: true,
      cancelButtonText: 'No',
      allowOutsideClick: false,
      allowEnterKey: false
    }).then(
      (respon) => {
        if (respon.value) {
          this._loadingAdd.show();
          this.subscrip.push(this.service.editAging(this.getDataEditAging()).subscribe(
            () => {
              this._loadingAdd.hiden();
              this.message('success', 'Successfully Updated');
              this.getChargesAndCreditsByTrip();
              this.onCloseEditAging();
            },
            error => {
              this._loadingAdd.hiden();
              this.message('error', error.message);
            }
          ));
        }
      }
    );
  }
  private getDataEditAging(): IDataEditAging {
    return {aging: this.changeAging, tripid: this.tripidInput} as IDataEditAging;
  }
  public onChangeDate(date: IMyDateModel): void {
    this.changeAging = date.formatted;
  }
  public updateGeneral(): void {
    this.getChargesAndCreditsByTrip();
    this.updateTrip.emit(this.tripidInput);
  }
  ngOnDestroy(): void {
    this.subscrip.forEach(
      (sub: Subscription) => sub.unsubscribe()
    );
  }

  setRowSelectedGrid(isCredit: boolean) {
    if (this.creditSelected.tripcreditid || this.chargeSelected.tripchargeid) {
      if (isCredit) {
        this.gridCredits.api.forEachNode((rowNode) => {
          rowNode.data.selectedGrid = (rowNode.data.tripcreditid === this.creditSelected.tripcreditid);
          rowNode.setData(rowNode.data);
        });
      } else {
        this.gridCharges.api.forEachNode((rowNode) => {
          rowNode.data.selectedGrid = (rowNode.data.tripchargeid === this.chargeSelected.tripchargeid);
          rowNode.setData(rowNode.data);
        });
      }
    }
  }

  getRowStyle(params) {
    if (params.data.selectedGrid) {
      return {
        'background-color': '#a2bcff',
        'color': '#000000'
      };
    } else {
      return {
        'background-color': '#ffffff',
        'color': '#000000'
      };
    }
  }

  reloadPayorId(event: any) {
    this.reloadTripId.emit(event);
  }

  verifyTripNonNegotiable(): void {
    this.subscrip.push(
      this.service.getTripNonNegotiable(this.tripId).subscribe((resp: any) => {
        this.nonnegotiable = resp;
        this.getChargesByTrip(this.tripId, this.reversing);
      }, (error) => {
        this.sweetAlertHelper.captureException(error);
      })
    );
  }

  verifyTripDuplicate() {
    this.subscrip.push(
      this.service.getTripDuplicate(this.tripId).subscribe((resp: any) => {
        this.isDuplicate = resp;
        this.getChargesByTrip(this.tripId, this.reversing);
      }, error => {
        this.sweetAlertHelper.createCustomAlert({
          title: 'Error',
          text: error.message,
          type: 'error',
        });
      })
    );
  }

  markNonNegotiable(): void {
    this.sweetAlertHelper
      .createCustomAlert({
        title: 'Non-negotiable',
        text:   `Are you sure to ${this.nonnegotiable ? 'mark' : 'unmark' } this trip as Non-negotiable?`,
        type: 'info',
        showCancelButton: true,
        cancelButtonText: 'No',
      })
      .then((result) => {
        if (result.value) {
          if (!this.nonnegotiable) {
            this.subscrip.push(
              this.service.deleteTripNonNegotiable(this.tripId).subscribe({
                next: (res) => {
                  if (res) {
                    this.sweetAlertHelper
                    .createCustomAlert({
                      title: 'Success',
                      text: 'Trip unmarked as "Non Negotiable"',
                      type: 'success',
                    })
                    .then((resultM) => {
                      if (resultM.value || resultM.dismiss) {
                        this.verifyTripDuplicate();
                      }
                    });
                  }
                },
                error: (e) => this.sweetAlertHelper.captureException(e),
              })
            );
          } else {
            this.subscrip.push(
              this.service.postTripNonNegotiable(this.tripId).subscribe({
                next: (res) => {
                  if (res) {
                    this.sweetAlertHelper
                      .createCustomAlert({
                        title: 'Success',
                        text: 'Trip marked as "Non Negotiable"',
                        type: 'success',
                      })
                      .then((resultM) => {
                        if (resultM.value || resultM.dismiss) {
                          this.verifyTripNonNegotiable();
                        }
                      });
                  }
                },
                error: (e) => {
                  this.sweetAlertHelper.captureException(e);
                }
              })
            );
          }
        } else {
          this.nonnegotiable =  !this.nonnegotiable;
        }
      });
  }

  markDuplicate() {
    this.sweetAlertHelper
      .createCustomAlert({
        title: 'Duplicate',
        text:  `By checking this box you ${this.isDuplicate ? 'are' : 'are not' }
        reporting this claims as "Not Duplicate". Are you sure you want to do this?`,
        type: 'info',
        showCancelButton: true,
        cancelButtonText: 'No',
      })
      .then((result) => {
        if (result.value) {
          if (!this.isDuplicate) {
            this.subscrip.push(
              this.service.deleteTripDuplicate(this.tripId).subscribe(
                (resp: Response) => {
                  if (resp.status === 204) {
                    this.sweetAlertHelper
                    .createCustomAlert({
                      title: 'Success',
                      text: 'Trip unmarked as "Not Duplicate"',
                      type: 'success',
                    })
                    .then((resultM) => {
                      if (resultM.value || resultM.dismiss) {
                        this.verifyTripDuplicate();
                      }
                    });
                  }
                },
                (error) => {
                  this.sweetAlertHelper.captureException(error);
                }
              )
            );
          } else {
            this.subscrip.push(
              this.service.postTripDuplicate(this.tripId).subscribe(
                (resp: Response) => {
                  if (resp.status === 204) {
                    this.sweetAlertHelper
                      .createCustomAlert({
                        title: 'Success',
                        text: 'Trip marked as "Not Duplicate"',
                        type: 'success',
                      })
                      .then((resultM) => {
                        if (resultM.value || resultM.dismiss) {
                          this.verifyTripDuplicate();
                        }
                      });
                  }
                },
                (error) => {
                  this.sweetAlertHelper.createCustomAlert({
                    title: 'Error',
                    text: error.message,
                    type: 'error',
                  });
                }
              )
            );
          }
        } else {
          this.isDuplicate = !this.isDuplicate;
        }
      });
  }

  get disabledBtnEditOrDelete(): boolean {
    return !this.isEdit || !this.chargeSelected.sequence;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/edit-reservation/edit-billing/components/add-charges-credits/add-charges-credits.component.ts